import { render, staticRenderFns } from "./KonfirmasiGiro.vue?vue&type=template&id=1210aeb8&scoped=true&"
import script from "./KonfirmasiGiro.vue?vue&type=script&lang=js&"
export * from "./KonfirmasiGiro.vue?vue&type=script&lang=js&"
import style0 from "./KonfirmasiGiro.vue?vue&type=style&index=0&id=1210aeb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210aeb8",
  null
  
)

export default component.exports